module.exports = __webpack_public_path__ + "img/background-balance-business-583846.581fd93a.jpg";